import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
  selector: 'app-progress-bar-cell',
  templateUrl: './progress-bar-cell.component.html',
  styleUrls: ['./progress-bar-cell.component.scss']
})
export class ProgressBarCellComponent implements ICellRendererAngularComp {
  params: any;

  constructor() {
  }
  agInit(params: any): void {
    this.params = params;
  }

  /**
   * @description
   * @returns {boolean}
   */
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/progress-bar-cell/progress-bar-cell.component.ts